"use client";
import * as React from "react";
const NotSupported = /*#__PURE__*/ React.forwardRef(function NotSupported({ _atom = "" }, ref) {
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref
    }, `This builtin is not currently supported: ${_atom}`);
});
export default NotSupported;
